import { MetricClient, ClientOutput } from '../../Clients/MetricClient';
import { call, put } from 'redux-saga/effects';
import { ApiGetter } from '../../Clients/ApiGetter';
import { actions } from '../../../reducers/ProjectDashboard/ProjectStats';

export const metricClient = new MetricClient(new ApiGetter());

interface GetProjectStatsAction {
  organizationUUID: string;
  repositoryUUID: string;
}

export function* getProjectStats({
  organizationUUID,
  repositoryUUID,
}: GetProjectStatsAction) {
  // We care about overall here, which is returned on the
  // object of MetricClient, so it doesn't matter the specific metric
  const arbitraryMetric = 'average_comments_per_review';

  const { data, error }: ClientOutput = yield call(
    [metricClient, metricClient.retrieveAsync],
    {
      organizationUUID,
      repositoryUUID,
      metric: arbitraryMetric,
      period: 30,
    }
  );

  if (error || !data) {
    yield put(actions.setProjectStats(undefined));
    return;
  }

  yield put(actions.setProjectStats(data.overall));
}
